import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { Answer } from "../answer"
import { CommentDetailProps } from "./types"
import { useStyles } from "./styles"
import { useMutation } from "@tanstack/react-query"
import { emitEvent } from "../../../../../../hooks/emitter"
import { Events } from "../../../../../../hooks/emitter/types"
import { scheduleServiceFetch } from "../../../../../../utils/constants/callService"
import { useState } from "react"
import { InputComment } from "../inputComment"
import { icons } from "../../../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { Types } from "../../../../../../utils/enums"

const CommentDetail = ({ comment, notAddComment, }: CommentDetailProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const [value, setComment] = useState<null | string>(null)
    const [addComent, setAddComent] = useState(false)
    const { isPending, mutate } = useMutation({
        mutationFn: scheduleServiceFetch.createComment,
        onSuccess: () => {
            setAddComent(false)
            setComment(null)
            emitEvent(Events.comment, undefined)
            emitEvent(Events.snackbar, {open: true, type: Types.SUCCESS, message: t('general.commentMessage.success')})
        },
        onError: () => {
            emitEvent(Events.snackbar, {open: true, type: Types.ERROR, message: t('general.commentMessage.error')})
        }
    })

    const displayComment = ({ value }: { value: boolean }) => {
        setAddComent(value)
        setComment(null)
    }

    const sendComment = async () => {
        if (!value) { return }

        mutate({ body: { comment: value, recurrenceCommentId: comment.id, recurrenceId: null } })
    }

    return (
        <>
            <Box sx={styles.comment}>
                <Box sx={styles.commentInfo}>
                    <Typography variant="subtitle_grey">{comment.date} - {comment.user}</Typography>
                    <Typography variant="text_grey">{comment.comment}</Typography>
                </Box>

                {!notAddComment && 
                    <Tooltip title={t(addComent ? t('schedule.buttons.cancelComment') : t('schedule.buttons.sendComment'))}>
                        <IconButton onClick={() => { displayComment({ value: !addComent }) }} className="color-primary">{icons(addComent ? 'cancel-message' : 'send')}</IconButton>
                    </Tooltip>
                }
            </Box>

            {
                !notAddComment && (
                    <InputComment
                        comment={value}
                        isPending={isPending}
                        show={!!addComent}
                        sendComment={async () => { sendComment() }}
                        setComment={setComment}
                    />
                )
            }
            <Box sx={styles.answers}>
                {
                    comment.answers?.map(answer => (<Answer answer={answer} />))
                }
            </Box>
        </>
    )
}

export { CommentDetail }